module.exports = __webpack_public_path__ + "cc74db6fb12fb27b90da467aa7e8b5ac.svg";